import { put, call, take, takeLatest, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  LOGIN_SAGA,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  VERIFY_SAGA,
  VERIFY_SUCCESS,
  VERIFY_ERROR,
} from "../actionTypes";

import { apiCaller } from "../../custom-hooks/useApi";
import { authentication_apiCalls } from "../../services/agent";

export function* loginSaga(action) {
  const { data, status } = yield apiCaller({
    api: authentication_apiCalls.apiCall_login,
    apiArguments: action.payload,
    toastMessage: true,
    onError: (ex) => {
      if (ex.response.data.mesage) {
        toast.error(ex.response.data.mesage);
      } else {
        toast.error("درخواست ورود با خطا مواجه شد");
      }
    },
  });

  if (status === 200) yield put({ type: LOGIN_SUCCESS });
  else yield put({ type: LOGIN_ERROR });
}

export function* verifySaga(action) {
  const { data, status } = yield apiCaller({
    api: authentication_apiCalls.apiCall_verify,
    apiArguments: action.payload,
    toastMessage: true,
    onError: (ex) => {
      if (ex.response.data.mesage) {
        toast.error(ex.response.data.mesage);
      } else {
        toast.error("درخواست ورود با خطا مواجه شد");
      }
    },
    onSuccessMessage: "به پنل فروشندگان مبلیکس خوش آمدید .",
  });

  if (status === 200)
    yield put({ type: VERIFY_SUCCESS, payload: data.data.token });
  else yield put({ type: VERIFY_ERROR });
}

export function* watchLoginSaga() {
  yield takeLatest(LOGIN_SAGA, loginSaga);
}

export function* watchVerifySaga() {
  yield takeLatest(VERIFY_SAGA, verifySaga);
}
